import { render, staticRenderFns } from "./Prevod.vue?vue&type=template&id=a97f4a44&scoped=true&"
import script from "./Prevod.vue?vue&type=script&lang=js&"
export * from "./Prevod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97f4a44",
  null
  
)

export default component.exports